<template>
  <section class="sessao-resultados" ref="result">
    <partial-modal-print :printModalResult="printModalResult"></partial-modal-print>

    <div id='form-actions' :class="{ 'text-center': centeredButtonsForm }">
      <partial-buttons
        @sendForm="sendForm"
        @setCommissionToAll="setCommissionToAll"
        @canSeeCommission="canSeeCommission"
        @openModalPrintResults="openModalPrintResults"
        :showedQuotationCount="showedQuotationCount"
        :canPrintResults="canPrintResults"
        :result="result"
        :commissionAccess="commissionAccess"
        :showCommission="showCommission" />
    </div>

    <NewPrintModal :modalId="NewPrintModalId"></NewPrintModal>

    <div class="container-fluid" id="resultados" ref="resultados">
      <div class="row title" ref="resultTitleBar">
        <div class='col-xs-3 col-sm-2 small-x-padding'>
          <a @click.prevent="orderByInsurer()">
            Seguradora
          <icon name="sort"></icon> 
          </a>
        </div>
        <div class='col-xs-3 col-sm-2 col-md-1 text-center small-x-padding'>
          {{commissionAccess && showCommission ? 'Comissão' : 'Ações' }}
        </div>
        <div class="col-xs-1 col-md-1 text-center hidden-xs hidden-sm small-x-padding">
          <a @click.prevent="orderByTime()">
            Tempo
            <icon name="sort-down"></icon>
          </a>
        </div>
        <div class="col-xs-3 col-md-2 text-left hidden-xs hidden-sm small-x-padding">Produto</div>
        <div class='col-xs-6 col-sm-4 col-md-2 text-center small-x-padding'>
          <a @click.prevent="orderByValue()">
            Valores
          <icon name="sort"></icon></a>
        </div>
      </div>

      <div>
        <partial-insurer
          v-for="insurer in insurers"
          :key="insurer.id"
          :insurer="insurer"
          :result="result"
          :showCommission="showCommission"
          :commissionAccess="commissionAccess"
          :insurerAccess="insurerAccess"
          :canPrintResults="canPrintResults"
          :commission="commission"
          :pdfs="pdfs"
          :fromFaye="fromFaye"
          :triggerResetAdditionals="triggerResetAdditionals">
        </partial-insurer>
      </div>
    </div> <!-- end resultados -->

    <div :class="{ 'text-center': centeredButtonsForm }">
      <partial-buttons
        @sendForm="sendForm"
        @setCommissionToAll="setCommissionToAll"
        @canSeeCommission="canSeeCommission"
        @openModalPrintResults="openModalPrintResults"
        :showedQuotationCount="showedQuotationCount"
        :canPrintResults="canPrintResults"
        :result="result"
        :commissionAccess="commissionAccess"
        :showCommission="showCommission" />
    </div><!-- end row -->
  </section>
</template>

<script>
  import PartialInsurer from "./PartialInsurer.vue";
  import PartialInsurerAdditionalProduct from "./PartialInsurerAdditionalProduct.vue";
  import PartialButtons from "./PartialButtons.vue";
  import PartialModalPrint from "./PartialModalPrint.vue";
  import dragula from "dragula";
  import jQuery from "jquery";
  import NewPrintModal from "./NewPrintModal.vue";
  import Select2 from 'shared/modules/Select2/Select2.vue'
  import axios from 'axios'    

  export default {
    components: {
      PartialButtons,
      PartialInsurer,
      PartialInsurerAdditionalProduct,
      PartialModalPrint,
      NewPrintModal,
      Select2
    },
    props: {insurers:Array},
    data() {
      return {
        resultSize: 0,
        resultErrorSize: 0,
        disableButtonQuote: false,
        showedQuotationCount: 0,
        showCommission: true,
        result: {},
        printModalResult: {},
        commission: "",
        pdfs: [],
        orderParams: {
          insurer: {
            by: ".col-seguradora-order span",
            direction: -1,
          },
          time: {
            by: ".col-segundos-order",
            direction: -1,
          },
          value: {
            by: ".col-valores-order a div",
            direction: -1,
          },
        },
        NewPrintModalId: "NewPrintModalId",
        triggerResetAdditionals: false
      };
    },
    watch: {
      fayeResult(result) {
        if (!result) return;
        if (result.action === "PDF") {
          this.insertPDF(result.data);
        }
      },
    },
    computed: {
      additionalProducts() {
        return this.$store.state.Result.additionalProducts;
      },
      canPrintResults() {
        return this.$root.$options.config.printResults;
      },
      centeredButtonsForm() {
        return this.$root.$options.config.centeredButtonsForm;
      },
      commissionAccess() {
        return this.$root.$options.config.commissionAccess;
      },
      insurerAccess() {
        return this.$root.$options.config.insurerAccess;
      },
      fayeResult() {
        return this.$store.state.faye.result;
      },
    },
    mounted() {
      this.initDragula();
      this.initFixedTitleBar();

      this.$root.$options.eventBus.$on("onValidatedQuotation", () =>
        this.enableDisableButtonsQuote(false)
      );
      this.$root.$options.eventBus.$on("onSavingQuotation", () =>
        this.enableDisableButtonsQuote(true)
      );
      this.$root.$options.eventBus.$on("onSavedQuotation", () =>
        this.enableDisableButtonsQuote(false)
      );
      this.$root.$options.eventBus.$on("onErrorQuotation", () =>
        this.enableDisableButtonsQuote(false)
      );

      this.$root.$options.eventBus.$on("invokeResultByInsure", (showed) => {
        this.showedQuotationCount = showed
          ? this.showedQuotationCount + 1
          : this.showedQuotationCount - 1;

        setTimeout(() => {
          this.$nextTick(() => {
            if (showed) {
              this.orderByTime();
            }
          });
        }, 10);
      });
    },
    methods: {
      sendForm() {
        let self = this

        self.triggerResetAdditionals = !self.triggerResetAdditionals
        this.$root.$options.eventBus.$emit("onSavingQuotation");
        this.$root.$options.eventBus.$emit("onValidateEnterpriseForm");
      },
      enableDisableButtonsQuote(active) {
        this.disableButtonQuote = active;

        this.$children.forEach((child) => {
          child.disableButtonQuote = active;
        });
      },
      canSeeCommission() {
        this.showCommission = !this.showCommission;
      },
      setCommissionToAll(commission) {
        this.commission = commission;
      },
      initDragula() {
        dragula({
          isContainer: function(el) {
            return el.classList.contains("can-drop");
          },
          moves: function(el, container, handle) {
            return handle.classList.contains("draggable");
          },
        })
          .on("drag", function(el, container) {
            jQuery(".can-drop").addClass("drop-active");
          })
          .on("dragend", function(el, container) {
            jQuery(".can-drop").removeClass("drop-active");
          });
      },
      initFixedTitleBar() {
        let headerHeight,
          positionResult,
          positionWindow,
          canFixTitleBar = false;

        jQuery(window).scroll(() => {
          // Leosoft
          headerHeight = jQuery(".container-nav-bar").length
            ? jQuery(".container-nav-bar").outerHeight()
            : 0;

          // Segfy
          headerHeight =
            jQuery("#head-nav").length &&
            jQuery("#head-nav").css("position") === "fixed"
              ? jQuery("#head-nav").outerHeight()
              : headerHeight;

          positionResult = jQuery(this.$refs.resultados).offset().top;
          positionWindow = jQuery(window).scrollTop() + headerHeight;
          canFixTitleBar = positionWindow > positionResult;

          jQuery(this.$refs.resultTitleBar)
            .css("width", canFixTitleBar ? this.$refs.resultados.offsetWidth + "px" : "inherit")
            .css("top", 0)
            .css("border-bottom", canFixTitleBar ? "2px solid #a6a6a6" : "0px")
            .css("position", canFixTitleBar ? "fixed" : "initial");
        });
      },
      orderByInsurer() {
        this.orderBy(this.orderParams.insurer);
      },
      orderByValue() {
        this.orderBy(this.orderParams.value, true);
      },
      orderByTime() {
        this.orderBy(this.orderParams.time, true);
      },
      insertPDF(pdf) {
        this.pdfs.push(pdf);
      },
      orderBy(item, convertToNumber = false) {
        let parent = document.querySelectorAll("div.data.resultado")[0]
          .parentElement;
        item.direction = item.direction * -1;

        var ordered = Array.prototype.slice
          .call(document.querySelectorAll("div.data.resultado"), 0)
          .sort((first, second) => {
            let firstValue = first.querySelector(item.by);
            let secondValue = second.querySelector(item.by);
            if (firstValue != null) {
              firstValue = firstValue.innerHTML;
              if (convertToNumber && firstValue != null) {
                firstValue = Number(
                  firstValue.replace(".", "").replace(",", ".")
                );
              }
            }
            if (secondValue != null) {
              secondValue = secondValue.innerHTML;
              if (convertToNumber && secondValue != null) {
                secondValue = Number(
                  secondValue.replace(".", "").replace(",", ".")
                );
              }
            }

            let result = 0;

            if (firstValue != null && secondValue != null)
              result =
                firstValue < secondValue ? -1 : firstValue > secondValue ? 1 : 0;
            else if (firstValue == null) result = 99 * item.direction;
            else if (secondValue == null) result = -1;
            else result = 99 * item.direction;

            return result * item.direction;
          });

        parent.innerHTML = "";
        ordered.forEach((x) => {
          parent.append(x);
        });
      },
      openModalPrintResults() {
        this.$store.dispatch(
          "exibeMensagemCarregamento",
          "Carregando relatório..."
        );

        let quotationId;

        if(this.$store.state.quotationId)      
          quotationId = this.$store.state.quotationId; 
        else
          quotationId = this.$root.$options.config.quotationId;  
        
        axios.post(this.$root.$options.config.environment.applicationUrlApiAutomation + "/api/enterprise/version/1.0/show", 
        {
          config: {
              token: this.$root.$options.config.token
          },
          data: {
              guid: quotationId
            }
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${this.$store.state.automationBearer}`
          }
        }).then(response => {
          this.$store.dispatch("closeLoading", 1000);
            setTimeout(() => {
              this.$root.$options.eventBus.$emit(
                "updatePrintResults",
                this.NewPrintModalId,
                response.data,
                response.data.quotation_id || this.$store.getters["quotationId"] || this.$root.$options.config.quotationId
              );
            }, 1000);
        }, err => {
          this.$store.dispatch(
            "exibeMensagemCarregamento",
              "Erro ao gerar relatório!"
          );
          this.$store.dispatch("closeLoading", 3000);
        });
        this.$store.dispatch("googleAnalytics", "/propostas?etapa=novoImprimir");
      }
    },
  };
</script>
<style src="residential/sass/result.scss" lang="sass" scoped></style>



// WEBPACK FOOTER //
// FormPartialResult.vue?baeeced4